import toDocument from '@/shared/directive/toDocument';

export default class ContractGroup {
  id: string;

  createdDate: string;

  name: string;

  cnpj: string;

  hasContract: boolean;

  customerName: string;

  active: boolean;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.createdDate = obj.createdDate || '';
    this.name = obj.name || '';
    this.cnpj = obj.cnpj || '';
    this.hasContract = obj.hasContract || false;
    this.customerName = obj.customerName || '';
    this.active = obj.active || false;
  }

  public static of(obj: any): ContractGroup {
    return new ContractGroup(obj || {});
  }

  public static ofList(obj: any = []): ContractGroup[] {
    return obj.map(this.of)
  }

  public getDescription(): string {
    const formattedCnpj = this.cnpj && this.cnpj.length === 14 ? toDocument(this.cnpj) : this.cnpj;
    return `${formattedCnpj} - ${this.name} ${this.active ? '' : '(Inativo)'}`;
  }
}
